angular.module('impactx.cscontract').controller('PriceGroupConditionDialogCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'TranslationService',
    'trns',
    'priceGroupPopup',
    'currentSelected',
    'baseId',
    'priceGroupSelected',
    PriceGroupConditionDialogCtrl]);

function PriceGroupConditionDialogCtrl($scope, dataGen, $mdDialog, TranslationService, trns, priceGroupPopup, currentSelected, baseId, priceGroupSelected) {
    var self = this;
    $scope.trns = trns;
    $scope.trns.abort = TranslationService.get("abort");
    $scope.trns.forward = TranslationService.get("forward");
    $scope.trns.search = TranslationService.get("search");
    $scope.priceGroupPopup = priceGroupPopup;
    $scope.currentSelected = currentSelected;
    $scope.currentTarget = {};
    $scope.currentSource = {};
    if (priceGroupSelected) {
        $scope.wizardIndex = 1;
    }
    else {
        $scope.wizardIndex = 0;
    }
    $scope.available = [];
    $scope.targetIndex = -1;

    self.getAvailableSourcesAndForward = function() {
        dataGen.postAsForm({}, {searchText: undefined, assigned: [], startIndex: 0, stepSize: -1, baseId: baseId},
            "/cscontract/disrelation/available").then(function(data) {
                $scope.available = data.data.entries;
                $scope.wizardIndex++
        })
    };

    self.selectTarget = function(target, index) {
        $scope.currentTarget = target;
        $scope.targetIndex = index;
    };

    self.selectSource = function(source) {
        $scope.currentSource = source;
    };

    self.forward = function () {
        if ($scope.wizardIndex === 0) {
            $scope.wizardIndex++;
        }
        else if ($scope.wizardIndex === 1) {
            self.getAvailableSourcesAndForward();
        }
        else if ($scope.wizardIndex === 2) {
            self.apply();
        }
    };

    self.apply = function() {
        $mdDialog.hide({priceGroup: priceGroupSelected ? priceGroupSelected : $scope.priceGroupPopup.selected.id,
            replace: {id: $scope.currentSource.id, xOrder: $scope.targetIndex, value: $scope.currentSource.value}});
    };

    self.abort = function (){
        $mdDialog.cancel();
    };

    self.filterConditions = function (searchText) {
        dataGen.postAsForm({}, {searchText: searchText, assigned: [], startIndex: 0, stepSize: -1, baseId: baseId},
            "/cscontract/disrelation/available").then(function(data) {
            $scope.available = data.data.entries;
        })
    }
}